import { useMutation } from "@apollo/client";
import { Button, Drawer, Form, message, Spin, Upload } from "antd";
import React, { useState } from "react";
import { UPDATE_TASK_STATUS_WITH_FILES_INSERT } from "../../../Graphql/mutations";
import { onFileUpload } from "../../Helper/MediaUploader";
import { CustIcon } from "../../Svgs";

import "./PictureRequiredAttachment.css";

const { REACT_APP_ASSETS_URL } = process.env;
const { Dragger } = Upload;

const PictureRequiredAttachmentDrawer = ({
  setIsPictureRequiredAttachmentVisible,
  isPictureRequiredAttachmentVisible,
  setSingleTaskDetails,
  singleTaskDetails,
}) => {
  const [uploadedFile, setUploadedFile] = useState(undefined);
  const [isUploading, setIsUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [UPDATE_TASK_STATUS_MUTATION, { loading: isUpdatingTask }] =
    useMutation(UPDATE_TASK_STATUS_WITH_FILES_INSERT);

  const onTutorialUploadSuccess = (fileUrl) => {
    setUploadedFile((prevState) => {
      return { ...prevState, fileUrl };
    });
    setFileList([...fileList, fileUrl]);
  };
  const beforeTutorialUpload = (file) => {
    if (file.type.includes("image")) {
      setUploadedFile({ type: file.type.split("/")[0] });
      return true;
    } else {
      message.error("Please upload Image Only");
      return Upload.LIST_IGNORE;
    }
  };
  const onUploadCompleteTask = async (file) => {
    if (fileList.length >= 1) {
      let taskObjectList = fileList.map((file) => {
        return {
          user_task_id: singleTaskDetails.user_task_id,
          file_name: file,
          file_type: "image",
        };
      });

      try {
        const isUpdateSuccessful = await UPDATE_TASK_STATUS_MUTATION({
          variables: {
            user_task_id: singleTaskDetails.user_task_id,
            user_id: localStorage.getItem("user_id"),
            note: "",
            objects: taskObjectList,
          },
        });
        if (!isUpdateSuccessful.errors) {
          message.success("Task Updated Successfully");
          setIsPictureRequiredAttachmentVisible(false);
          setFileList([]);
          setSingleTaskDetails(undefined);
        } else {
          message.error("Something went wrong...");
        }
      } catch (error) {}
    } else {
      message.error("Please upload Image(s)");
    }
  };

  const onClosePictureRequiredAttachmentDrawer = () => {
    setIsPictureRequiredAttachmentVisible(false);
    setFileList([]);
    setSingleTaskDetails(undefined);
  };
  
  return (
    <Drawer
      placement="right"
      destroyOnClose={true}
      closable={false}
      width={720}
      maskStyle={{ backgroundColor: "#000000CC" }}
      title="Click a picture to show you have done it"
      onClose={onClosePictureRequiredAttachmentDrawer}
      visible={isPictureRequiredAttachmentVisible}
    >
      <div className="d-flex p-3 flex-column ">
        <div className="pictureTaskRequiredAttachment">
          <div
            className={`${singleTaskDetails.task.taskType.type} taskDetailsSection`}
          >
            <h5>{singleTaskDetails.task.taskType.type_name}</h5>
            <p>{singleTaskDetails.task.description}</p>
          </div>
          <div className="uploadSection">
            {fileList.length < 3 && (
              <Dragger
                showUploadList={false}
                customRequest={(e) => {
                  setIsUploading(true);
                  onFileUpload(
                    e,
                    `task/${singleTaskDetails.user_task_id}`,
                    onTutorialUploadSuccess,
                    setIsUploading
                  );
                }}
                beforeUpload={beforeTutorialUpload}
              >
                <p className="ant-upload-drag-icon">
                  <CustIcon type="upload" />
                </p>
                <p className="ant-upload-text">Upload image</p>
                <small className="ant-upload-text">
                  Max. 3 images can be uploaded (.png, .jpg formats only)
                </small>
              </Dragger>
            )}
            {isUploading && (
              <div className="loaderFile mb-3">
                <Spin />
              </div>
            )}
          </div>
          <div className="uploadedFile_blk pt-3">
            {fileList.length > 0 &&
              fileList.map((file, index) => (
                <div className="uploadedFile mb-3" key={index}>
                  <img className="" src={REACT_APP_ASSETS_URL + file}></img>
                  <span
                    onClick={() =>
                      setFileList(
                        fileList.filter(function (item) {
                          return item !== file;
                        })
                      )
                    }
                  >
                    <CustIcon type="close" />
                  </span>
                </div>
              ))}
            
          </div>

          <div className="py-2 px-3 mb-4 text-secondary font-weight-500 text-center">
            By marking this task as complete you are personally attesting to
            it's accurate and thorough completion
          </div>
          <div className="text-center">
            <Button
              type="default"
              shape="round"
              onClick={onClosePictureRequiredAttachmentDrawer}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="ml-2"
              loading={isUpdatingTask}
              shape="round"
              onClick={onUploadCompleteTask}
            >
              Continue
            </Button>
          </div>
        </div>

        <small className="pt-3">
          All pictures and documents submitted via the SanAttest website become
          and remain the property of SanAttest, LLC. Use of the SanAttest
          program is confirmation of your understanding and acceptance of this
          requirement.
        </small>
      </div>
    </Drawer>
  );
};

export default PictureRequiredAttachmentDrawer;
